import { isAdmin, isInternal, isSupplier, shouldNotTrack } from "./internal_user_check_helpers";

const service = function($rootScope) {
  this.isSupplier = isSupplier

  this.isInternal = isInternal

  this.isAdmin = isAdmin

  this.shouldNotTrack = shouldNotTrack

  this.shouldNotTrackAnywhere = function() {
    return (this.isAdmin() || this.isInternal())
  }
}

service.$inject = ['$rootScope'];

tiz.service('InternalUserCheck', service);

export default service